import scrollToTopHtml from './scrolltotop.component.html';
import './scrolltotop.component.scss';

class ScrollToTopController {
    constructor($scope, $timeout, $window) {
        'ngInject';

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$window = $window;
        this.visible = this.alwaysVisible === 'true';

        if (this.alwaysVisible === 'true') {
            return;
        }

        angular.element(this.$window).on('scroll', (e) => {
            if (this.visible === false && window.scrollY > 500) {
                this.show();
            }

            if(this.visible === true && window.scrollY < 500) {
                this.hide();
            }
        });
    }

    show() {
        this.visible = true;
        this.$scope.$apply();
    }

    hide() {
        this.visible = false;
        this.$scope.$apply();
    }

    scroll() {
        this.$window.scrollTo(0, 0);
    }

    $onInit() {

    }
}

let scrollToTopComponent = {
    bindings: {
        alwaysVisible: '@',
        description: '@'
    },
    template: scrollToTopHtml,
    controller: ScrollToTopController
};

export default scrollToTopComponent;
